import styled, { css } from "styled-components";

import { fadeIn } from "@/styles/Mixins";
import { IThemeProps } from "@/styles/Theme";

/**
 * Slider Component Styles
 */
export const SliderWrapper = styled.div<any>`
  overflow: hidden;
  ${(props: any) => props.disabled && `pointer-events: none;`}
`;

type SliderContainerProps = IThemeProps<{
  backgroundImageUrl?: string;
  backgroundColor?: string;
}>;
export const SliderContainer = styled.div<SliderContainerProps>`
  background-color: ${(props: SliderContainerProps) =>
    props.backgroundImageUrl ? "rgb(0, 0, 0, 0.4)" : props.backgroundColor};
  touch-action: manipulation;
  border-radius: ${(props: SliderContainerProps) =>
    props.theme.borders.interaction || "0px"};
`;

type SlidesWrapperProps = IThemeProps<{
  transition: boolean;
  timing: number;
}>;
export const SlidesWrapper = styled.div<SlidesWrapperProps>`
  position: relative;
  display: flex;
  min-height: ${(props: SlideContainerProps) =>
    props.theme.globals.minInteractionHeight};
  ${(props: SlidesWrapperProps) =>
    props.transition &&
    `transition: left ${props.timing}ms cubic-bezier(0.250, 0.460, 0.450, 0.940);`}
`;

const SliderBackgroundAnimate = css`
  animation: ${fadeIn} ${(props: SliderBackgroundProps) => props.timing}ms;
  animation-fill-mode: forwards;
`;

export const SlideBackgroundImage = css`
  background-image: url(${(props: SliderBackgroundProps) =>
    props.backgroundImageUrl}?width=580);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: rgb(0, 0, 0, 0.4);
  background-blend-mode: overlay;
`;

type SliderBackgroundProps = IThemeProps<{
  backgroundImageUrl: string;
  timing?: number;
}>;
export const SliderBackground = styled.div<SliderBackgroundProps>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  ${(props: SliderBackgroundProps) => props.timing && SliderBackgroundAnimate};
  ${SlideBackgroundImage};
`;

/**
 * Slide Component Styles
 */
type SlideContainerProps = IThemeProps<{
  isActive?: boolean;
}>;
export const SlideContainer = styled.div<SlideContainerProps>`
  flex-basis: 100%;
  flex-shrink: 0;
  ${(props: SlideContainerProps) => (!props.isActive ? "height: 0;" : "")}
`;

export const SlideContent = styled.div<IThemeProps>`
  min-height: ${(props: SlideContainerProps) =>
    props.theme.globals.minInteractionHeight};
  display: flex;
  align-items: center;
  justify-content: center;
`;
